import * as React from 'react';
const SvgAccordianToggleIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 12H17" stroke={props.isOpen ? 'var(--ax-black)' : 'var(--ax-gold)'} strokeWidth={2} />
    {!props.isOpen && <path d="M12 7L12 17" stroke={props.isOpen ? 'var(--ax-black)' : 'var(--ax-gold)'} strokeWidth={2} />}
    <circle cx={12} cy={12} r={11} stroke={props.isOpen ? 'var(--ax-black)' : 'var(--ax-gold)'} strokeWidth={2} />
  </svg>
);
export default SvgAccordianToggleIcon;
